export default __webpack_public_path__ + "static/media/da_ngon_ngu_en.c385d371.png";